<template>
  <div id="app-info">
    <div class="app-content">
      <div class="app-info" style="position: relative">
        <p class="app-name">音频提取器</p>
        <p class="app-msg1">一款操作简单的音频提取音频编辑工具，支持音频剪辑</p>
        <p class="app-msg2">格式转换、音频合并、音量调整、音频调速、音频降噪</p>
        <p class="app-msg2">淡入淡出、音频混合、提取伴奏、录音、空间渲染。</p>

        <!-- <a
          id="download-apk"
          class="download-apk-android"
          href="http://audioeditor.videoshot.cn/audioeditor.apk"
        >
          <span>免费下载</span>
        </a> -->

        <div class="app-update-time">更新时间：2025-09-15 版本号：V 7.2.0</div>
        <div class="app-size-system">软件大小：63.5MB 适合系统：Android</div>
      </div>

      <div class="app-screenshot">
        <ul class="screenshot">
          <div class="imageList">
            <el-image
              v-for="(item, index) in urlList"
              :key="index"
              :src="item"
              :preview-src-list="getPreviewImgList(index, urlList)"
            >
            </el-image>
          </div>

          <div class="imagePreview">
            <el-image-viewer
              class="shreenshots"
              v-if="showViewer"
              :initial-index="1"
              :on-close="onClose"
              :on-switch="onSwitch"
              :url-list="urlList"
            />
          </div>
        </ul>
      </div>

      <!-- <ul class="qr-layout-root">
        <div class="qr-layout-div">
          <ul class="qr-img1-ul">
            <li class="qr-code-img-li">
              <img
                class="qr_code_img"
                src="http://audioeditor.videoshot.cn/qr_code_download.jpg"
              />
            </li>
            <li class="qr_code_text">扫一扫下载APK&nbsp; &nbsp;</li>
          </ul>
        </div>

        <div class="qr-layout-div">
          <ul class="qr-img1-ul">
            <li class="qr-code-img-li">
              <img
                class="qr_code_img"
                src="http://audioeditor.videoshot.cn/img_wx_code_bg.png"
              />
            </li>
            <li class="qr_code_text">扫码关注公众号&nbsp; &nbsp;</li>
          </ul>
        </div>
      </ul> -->
    </div>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {

  name: 'AppInfo',

  components: {
    ElImageViewer
  },

  data () {
    return {
      // 是否显示
      showViewer: false,
      urlList: [
        // require('@/assets/1.png'),
        // require('@/assets/2.png'),
        // require('@/assets/3.png'),
        // require('@/assets/4.png')
      ]
    }
  },

  methods: {

    getPreviewImgList (index, imgArr) {
      let arr = []
      let i = 0
      for (i; i < imgArr.length; i++) {
        arr.push(imgArr[i + index])
        if (i + index >= imgArr.length - 1) {
          index = 0 - (i + 1)
        }
      }
      return arr
    },

    // 打开查看器
    onPreview (showViewerUrl) {
      this.showViewerUrl = showViewerUrl
      this.showViewer = true
    },

    // 关闭图片预览
    onClose () {
      this.showViewer = false
    },

    // 切换图片 index为图片下标值
    onSwitch (index) {
      console.log(index)
    }
  }
}

</script>

<style>
.app-info {
  float: left;
  width: 500px;
}
.app-screenshot {
  margin-top: 200px;
  float: right;
  width: 637px;
  position: relative;
}
.app-content {
  width: 1200px;
  margin: 0 auto;
  clear: both;
}
.app-name {
  font-size: 40px;
  color: #fff;
  text-align: left;
  margin-top: 130px;
}
.app-msg1 {
  font-size: 20px;
  margin-top: 15px;
  color: #fff;
  text-align: left;
}
.app-msg2 {
  font-size: 20px;
  text-align: left;
  margin-top: 15px;
  color: #fff;
}
.download-apk-android {
  display: block;
  width: 200px;
  height: 80px;
  font-size: 16px;
  text-align: center;
  margin-top: 109px;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}
.download-apk-android span {
  background: url(~@/assets/down-app-android.png) 30px center no-repeat;
  text-indent: 50px;
  font-size: 22px;
  color: #347aeb;
  text-align: center;
  float: left;
  height: 80px;
  line-height: 80px;
  width: 100%;
}
.app-update-time {
  text-align: left;
  font-size: 16px;
  color: #fff;
  margin-top: 55px;
  margin-bottom: 20px;
}
.app-size-system {
  text-align: left;
  font-size: 16px;
  color: #fff;
  margin-bottom: 20px;
}
.app-screenshot ul {
  margin: 0px auto;
  list-style-type: none;
  float: right;
  white-space: nowrap;
}
.app-screenshot ul img {
  width: 160px;
  height: 284px;
  margin-right: 10px;
}

.qr-layout-root {
  display: inline-block;
  text-align: right;
  flex-direction: row;
}
.qr-layout-div {
  display: inline-block;
}
.qr-img1-div {
  text-align: right;
  display: inline-block;
  flex-direction: column;
}
.qr-img1-ul {
  text-align: right;
}
.qr_code_text {
  text-align: right;
  font-size: 15px;
  text-align: right;
  margin-top: 15px;
  color: #fff;
  display: inline-block;
  list-style: none;
  margin-right: 50px;
}
.qr-code-img-li {
  list-style: none;
}
.qr_code_img {
  width: 130px;
  height: 130px;
  margin-top: 50px;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppInfo.vue